/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* `httpResource` is still an experimental feature - NOT PRODUCTION READY
* Generated Angular service for UserResource
* Do not edit this file manually
*/
import { HttpContext, HttpContextToken, HttpHeaders, HttpParams, httpResource, HttpResourceOptions, HttpResourceRef, HttpResourceRequest } from "@angular/common/http";
import { inject, Injectable, Signal } from "@angular/core";
import { BASE_PATH_DEFAULT, CLIENT_CONTEXT_TOKEN_DEFAULT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { GetCurrentUserResponse, GetPermissionsResponse, GetUsersResponse } from "../models";

@Injectable({ providedIn: "root" })
export class UserResource {
    private readonly basePath: string = inject(BASE_PATH_DEFAULT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_DEFAULT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'default');
    }

    getCurrentUser(resourceOptions: HttpResourceOptions<GetCurrentUserResponse, unknown> & { defaultValue: NoInfer<GetCurrentUserResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetCurrentUserResponse>;
    getCurrentUser(resourceOptions?: HttpResourceOptions<GetCurrentUserResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetCurrentUserResponse | undefined>;
    getCurrentUser(resourceOptions?: HttpResourceOptions<GetCurrentUserResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetCurrentUserResponse | undefined> {
        return httpResource(() => {
            return {
                url: `${this.basePath}/User/me`,
                method: "GET",
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }

    getPermissions(userAccountId: Signal<string> | string, resourceOptions: HttpResourceOptions<GetPermissionsResponse, unknown> & { defaultValue: NoInfer<GetPermissionsResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetPermissionsResponse>;
    getPermissions(userAccountId: Signal<string> | string, resourceOptions?: HttpResourceOptions<GetPermissionsResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetPermissionsResponse | undefined>;
    getPermissions(userAccountId: Signal<string> | string, resourceOptions?: HttpResourceOptions<GetPermissionsResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetPermissionsResponse | undefined> {
        return httpResource(() => {
            return {
                url: `${this.basePath}/User/${typeof userAccountId === 'function' ? userAccountId() : userAccountId}/permissions`,
                method: "GET",
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }

    getUsers(resourceOptions: HttpResourceOptions<GetUsersResponse, unknown> & { defaultValue: NoInfer<GetUsersResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetUsersResponse>;
    getUsers(resourceOptions?: HttpResourceOptions<GetUsersResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetUsersResponse | undefined>;
    getUsers(resourceOptions?: HttpResourceOptions<GetUsersResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetUsersResponse | undefined> {
        return httpResource(() => {
            return {
                url: `${this.basePath}/User`,
                method: "GET",
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }

    getUserAvatar(id: Signal<number> | number, resourceOptions: HttpResourceOptions<Blob, Blob> & { defaultValue: NoInfer<Blob> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<Blob>;
    getUserAvatar(id: Signal<number> | number, resourceOptions?: HttpResourceOptions<Blob, Blob>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<Blob | undefined>;
    getUserAvatar(id: Signal<number> | number, resourceOptions?: HttpResourceOptions<Blob, Blob>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<Blob | undefined> {
        return httpResource.blob(() => {
            return {
                url: `${this.basePath}/User/${typeof id === 'function' ? id() : id}/Avatar`,
                method: "GET",
                responseType: 'blob' as 'blob',
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }
}
